"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeTitleEscrowAddress = void 0;
var _ethers = require("ethers");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const ethers = _objectSpread({}, _ethers.ethers);
if (ethers.version.includes("/5")) {
  ethers.keccak256 = ethers.utils.keccak256;
  ethers.solidityPackedKeccak256 = ethers.utils.solidityKeccak256;
  ethers.solidityPacked = ethers.utils.solidityPack;
  ethers.getCreate2Address = ethers.utils.getCreate2Address;
}

/**
 * @deprecated not be used with W3C VC
 */
const computeTitleEscrowAddress = params => {
  const implementationAddress = params.implementationAddress,
    factoryAddress = params.factoryAddress,
    registryAddress = params.registryAddress,
    tokenId = params.tokenId;
  const initCodeHash = ethers.keccak256(`0x3d602d80600a3d3981f3363d3d373d3d3d363d73${implementationAddress.substring(2)}5af43d82803e903d91602b57fd5bf3`);
  const salt = ethers.solidityPackedKeccak256(["bytes"], [ethers.solidityPacked(["address", "uint256"], [registryAddress, tokenId])]);
  return ethers.getCreate2Address(factoryAddress, salt, initCodeHash);
};
exports.computeTitleEscrowAddress = computeTitleEscrowAddress;